import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';

const biLogger = biLoggerFactory('lp', 19, { msid: 'aaffc05f-e278-4f75-b765-8c72c05765fb' });


async function fireEvent(buttonName) {
	try {
		const biEventObject = {
			evid: 703,
			button_name: buttonName,
			is_valid: true,
			topic: 'wix partners site',
			url: wixLocation.url
		};
		await biLogger.log(biEventObject);
	} catch (error) {
		console.log(error, "sth went wrong")
	}
}

export async function partnerProgram_click(event) {
	const biEventObject = {
		evid: 703,
		button_name: 'partners hp',
		is_valid: true,
		topic: 'wix partners site',
		url: wixLocation.url
	};
	await biLogger.log(biEventObject);
}

async function fireLetsTalkEvent(button) {
    try {
        const biEventObject = {
            evid: 703,
            button_name: button,
            is_valid: true,
            topic: "partners site",
            url: wixLocation.url,
            Additional_info: "eComme page page header"
        };
        await biLogger.log(biEventObject);
    } catch (error) {
        console.log(error, "sth went wrong")
    }
}

export function startNowNav_click(event) {
	fireLetsTalkEvent("Let's Talk")
}